import { toast } from 'react-toastify';

export function ToastHandler(message, style) {
  return toast.success(message, { className: style })
}


